import { defaultPaginationQuery, PaginationQuery } from "@/types/common";
import { flattenQuery, searchParamsQuery } from "@/utils/flatternQuery";
import { FileDownload as FileDownloadIcon } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import { useState } from "react";
import { downloadFile } from "@/utils/downloadUtils";

interface BtnExcelDownloadProps<T extends PaginationQuery> {
  apiUrl: string;
  disabled?: boolean;
  searchQuery?: T;
  title?: string;
}

const BtnExcelDownload = <T extends PaginationQuery>({
  apiUrl,
  disabled = false,
  searchQuery = defaultPaginationQuery as T,
  title = "엑셀 다운로드",
}: BtnExcelDownloadProps<T>) => {
  const [loading, setLoading] = useState(false);
  const handleDownload = async () => {
    try {
      setLoading(true);
      const queryStr = searchParamsQuery(flattenQuery(searchQuery)) ?? "";
      const url = queryStr ? `${apiUrl}?${queryStr}` : `${apiUrl}`;
      await downloadFile(url);
    } catch (e) {
      console.error("Download failed", e);
    } finally {
      setTimeout(() => setLoading(false), 1000);
    }
  };

  return (
    <Button
      variant='outlined'
      startIcon={loading ? <CircularProgress size={18} color='inherit' /> : <FileDownloadIcon />}
      onClick={handleDownload}
      disabled={disabled || loading}
      sx={{
        minWidth: "120px",
        height: "40px",
        borderColor: "#217346",
        color: "#217346",
        "&:hover": {
          borderColor: "#1a5c38",
          color: "#1a5c38",
        },
      }}
    >
      {loading ? "다운로드 중..." : title}
    </Button>
  );
};

export default BtnExcelDownload;
